var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gfu-header__actions gfu-navbar-nav",
      attrs: { "data-qa": "navbar-header-actions" },
    },
    [
      _c(
        "button",
        {
          staticClass:
            "gfu-navbar-btn gfu-navbar-btn--narrow gfu-search-button",
          attrs: {
            type: "button",
            "aria-label": _vm.Resources.Layout.SearchFormSearchButtonLabel,
          },
          on: { click: _vm.onSearchToggle },
        },
        [_c("base-icon", { attrs: { name: "search", size: "lg" } })],
        1
      ),
      _vm._v(" "),
      _vm.isCurrencySelectorVisible
        ? _c(
            "div",
            {
              staticClass: "gfu-navbar-item _screen--none _screen--flex-m",
              attrs: { "data-qa": "header-actions:CurrencySelector" },
            },
            [
              _c("currency-selector", {
                staticClass: "gfu-navbar-btn gfu-navbar-btn--narrow",
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLanguageSelectorVisible ? _c("language-selector-button") : _vm._e(),
      _vm._v(" "),
      _vm.isCartBoxVisible ? _c("cart-box") : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("div", { staticClass: "gfu-navbar-item" }, [
            _c(
              "a",
              {
                staticClass: "gfu-navbar-link--no-fx _cur-p _tdn",
                attrs: {
                  href: _vm.backerCenterDashboardUrl,
                  title: _vm.Resources.BackerCenter.YourDashboardPageTitle,
                  "aria-label":
                    _vm.Resources.BackerCenter.YourDashboardPageTitle,
                  "data-qa": "header-actions:BackerCenter",
                },
              },
              [
                _c("base-icon", {
                  staticClass: "gfu-navbar-btn gfu-navbar-btn--narrow",
                  attrs: {
                    name: "books-icon",
                    size: "lg",
                    "icon-namespace": "ga",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? [
            _c("mobile-notification-center"),
            _vm._v(" "),
            _c("mobile-user-navigation", {
              attrs: { "data-qa": "mobile-user-navigation" },
            }),
            _vm._v(" "),
            _c("mobile-navigation"),
          ]
        : [_c("push-notification-manager"), _vm._v(" "), _c("user-box")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }